export const LOAD_TRAINING_CALENDAR_DATA = 'app/brainProfilePage/LOAD_TRAINING_CALENDAR_DATA';
export const TRAINING_CALENDAR_DATA_LOADED = 'app/brainProfilePage/TRAINING_CALENDAR_DATA_LOADED';
export const TRAINING_CALENDAR_DATA_LOAD_ERROR = 'app/brainProfilePage/TRAINING_CALENDAR_DATA_LOAD_ERROR';
